import { z } from 'zod';
import { standardizedLabelSchema, standardizedLabelRelationsSchema } from '../../../schemas/standardizedLabel.schemas';
import { createResponseSchema } from '../../../schemas/repository.schemas';

export const standardizedLabelListResponseSchema = createResponseSchema(z.array(standardizedLabelSchema));
export type StandardizedLabelListResponseSchemaType = z.infer<typeof standardizedLabelListResponseSchema>;


export const standardizedLabelResponseSchema = createResponseSchema(standardizedLabelSchema)
export type StandardizedLabelResponseSchemaType = z.infer<typeof standardizedLabelResponseSchema>

export const standardizedLabelRelationsResponseSchema = createResponseSchema(standardizedLabelRelationsSchema);
export type StandardizedLabelRelationsResponseSchemaType = z.infer<typeof standardizedLabelRelationsResponseSchema>;
